<style scoped>
.base-card {
  border-radius: 15px !important;
  margin: 0 auto;
}
</style>

<template>
  <v-card max-width="460" class="elevation-4 px-6 base-card">
    <slot name="top"></slot>

    <anchor-logo />

    <div v-if="tip" align="center" justify="center">
      <p class="text--secondary text-center">
        {{ tip }}
      </p>
    </div>

    <slot></slot>
  </v-card>
</template>

<script>

export default {
  name: 'UnauthBaseCard',
  props: {
    tip: String,
  },
};
</script>
